module.exports = __webpack_public_path__ + "static/media/network-icon.528a4bb4.svg";